<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <!-- Lightbox -->
    <vue-easy-lightbox
      :visible="isLightboxVisible"
      :imgs="lightboxImg"
      @hide="isLightboxVisible = false"
    />
    <v-container fluid grid-list-md class="my-2" v-if="kine">
      <v-layout row wrap>
        <!-- BADGE kine -->
        <v-flex md4 order-md1>
          <div>
            <v-card outlined height="full-height" class="mx-auto">
              <v-img
                contain
                :aspect-ratio="1"
                :alt="kine.name"
                style="cursor: pointer;"
                @click="isLightboxVisible=true;lightboxImg=kine.photoUrl"
                :lazy-src="photoConvert(kine.photoUrl)"
                :src="photoConvert(kine.photoUrl)"
                height="200px"
              ></v-img>
              <v-card-title>{{ kine.name }}</v-card-title>
              <v-card-text class="mx-2">{{ kine.description }}</v-card-text>
              <v-list>
                <v-list-item v-if="kine.phone">
                  Prix:
                  <span class="body-2">{{kine.physio.sessionPrice}}dt /séance</span>
                </v-list-item>
                <v-list-item v-if="kine.phone">
                  <v-list-item-icon>
                    <v-icon color="secondary">mdi-phone</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>+216 - {{ kine.phone }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="kine.mail">
                  <v-list-item-icon>
                    <v-icon color="secondary">mdi-email</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ kine.mail }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <SocialMedia
                  :facebook="kine.facebook"
                  :instagram="kine.instagram"
                  :website="kine.website"
                  :youtube="kine.youtube"
                />
              </v-list>
              <v-flex xs12 fill-height>
                <v-card justify-center wrap flat class="text-center pa-2">
                  Notez {{kine.name}}
                  <v-rating></v-rating>
                </v-card>
              </v-flex>
            </v-card>
          </div>
        </v-flex>

        <!-- CONTENT -->
        <v-flex md8 order-md2>
          <v-layout row>
            <v-flex>
              <!-- Schedule -->
              <v-card height="100%" class="text-center pa-2" outlined>
                <ScheduleCard :openningHours="kine.physio.openningHours" />
              </v-card>
            </v-flex>
            <v-flex v-if="kine.city || kine.country || kine.zipCode">
              <v-card justify-center wrap height="100%" class="text-center pa-2" outlined>
                <p>{{kine.adress}},</p>
                <p class="font-weight-light">
                  <span v-if="kine.country">{{kine.country+","}}</span>
                  <span v-if="kine.city">{{kine.city+","}}</span>
                  {{kine.zipCode}}
                </p>
              </v-card>
            </v-flex>
            <v-flex>
              <!-- materials  -->
              <v-card justify-center wrap height="100%" class="text-center" outlined>
                <v-row>
                  <v-col cols="4">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon style="margin-bottom: 4px;" left v-on="on">mdi-package-variant</v-icon>
                      </template>
                      <span>Matériels</span>
                    </v-tooltip>
                    <div v-if="kine.physio.equipments.length>0">
                      <p
                        class="body-2"
                        style="margin-bottom: 2px;"
                        v-for="(item,i) in kine.physio.equipments"
                        :key="i"
                      >{{item}}</p>
                    </div>
                    <p
                      v-else
                      class="body-2 text--secondary"
                      style="margin-bottom: 2px;"
                    >aucun matériels</p>
                  </v-col>
                  <v-col cols="4">
                    <p style="margin-bottom: 4px;" class="font-weight-bold body-2">Mobilité</p>
                    <div v-if="kine.physio.external">
                      <p
                        class="body-2"
                        style="margin-bottom: 2px;"
                        v-for="(item,i) in kine.physio.external"
                        :key="i"
                      >{{item}}</p>
                    </div>
                    <p
                      v-else
                      class="body-2 text--secondary"
                      style="margin-bottom: 2px;"
                    >pas de séance à domicile</p>
                  </v-col>
                  <v-col cols="4">
                    <p style="margin-bottom: 4px;" class="font-weight-bold body-2">Spécialités</p>
                    <div v-if="kine.physio.specialities.length>0">
                      <p
                        class="body-2"
                        style="margin-bottom: 2px;"
                        v-for="(item,i) in kine.physio.specialities"
                        :key="i"
                      >{{item}}</p>
                    </div>
                    <p
                      v-else
                      class="body-2 text--secondary"
                      style="margin-bottom: 2px;"
                    >aucune spécialité mentionnée</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-flex>
            <v-flex md12 v-if="kine.physio.experience">
              <v-card justify-center wrap height="100%" class="text-center pa-2" outlined>
                <v-tabs v-model="tab">
                  <v-tab>Expérience</v-tab>
                  <v-tab>Diplomes</v-tab>
                  <!-- Experiences -->
                  <v-tab-item>
                    <v-container
                      v-for="(item, i) in kine.physio.experience"
                      :key="i"
                      class="d-flex justify-start"
                    >
                      <ExperienceComponent :experience="item" />
                    </v-container>
                  </v-tab-item>
                  <!-- Diplomas -->
                  <v-tab-item>
                    <v-container
                      v-for="(item, i) in kine.physio.diploma"
                      :key="i"
                      class="d-flex justify-start"
                    >
                      <DiplomaComponent :diploma="item" />
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SocialMedia from "@/components/SocialMediaWidget.vue";
import DisponibilityCard from "@/components/coachComponents/DisponibiltyCard.vue";
import ExperienceComponent from "@/components/partnerComponents/ExperienceComponent.vue";
import DiplomaComponent from "@/components/partnerComponents/DiplomaComponent.vue";
import ScheduleCard from "@/components/partnerComponents/ScheduleCard.vue";

export default {
  props: ["id"],
  components: {
    SocialMedia,
    DisponibilityCard,
    ExperienceComponent,
    DiplomaComponent,
    ScheduleCard
  },
  data() {
    return {
      tab: null,
      isLightboxVisible: false,
      lightboxImg: ""
    };
  },
  beforeMount() {
    this.getKine(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      getKine: "loadKineById"
    }),
    photoConvert(url) {
      if (url === null || url === undefined) {
        return process.env.VUE_APP_API_URL_COACH_AVATAR;
      }
      if (url.startsWith("https://sprint-app.com")) return url;
      else return url + "?height=500";
    }
  },
  computed: {
    ...mapGetters({
      kine: "getKineById",
      loading: "loading"
    })
  }
};
</script>
<style scoped>
</style>